import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/slices/authSlice';
import { 
  FaHome, 
  FaBriefcase, 
  FaUsers, 
  FaCrown, 
  FaFileAlt, 
  FaComments, 
  FaPalette,
  FaLock,
  FaChartLine,
  FaSignOutAlt,
  FaAngleLeft,
  FaAngleRight
} from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ isCollapsed, onToggle, mobileShow, closeMobile }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { staff } = useSelector((state) => state.auth);

  const menuItems = [
    { path: '/', label: 'Resumen', icon: <FaHome /> },
    { path: '/jobs', label: 'Ofertas', icon: <FaBriefcase /> },
    { path: '/users', label: 'Usuarios', icon: <FaUsers /> },
    { path: '/employers-manager', label: 'Gestor Premium', icon: <FaCrown /> },
    { path: '/applications', label: 'Candidaturas', icon: <FaFileAlt /> },
    { path: '/conversations', label: 'Mensajería', icon: <FaComments /> },
    { path: '/analytics', label: 'Analíticas', icon: <FaChartLine /> },
    { path: '/appearance', label: 'Apariencia', icon: <FaPalette /> },
    { path: '/security', label: 'Seguridad', icon: <FaLock /> },
  ];

  const handleLogout = () => {
    dispatch(logout());
    if (closeMobile) closeMobile();
  };

  const isMobile = window.innerWidth <= 768;
  const showFull = !isCollapsed || isMobile;

  return (
    <aside className={`admin-sidebar ${isCollapsed && !isMobile ? 'collapsed' : ''}`}>
      <div className="sidebar-brand">
        <div className="brand-logo">
          <img
            src="https://mundotrabajos.es/images/brand/logo-mundotrabajos.png"
            alt="MundoTrabajos"
            onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.textContent = 'MT'; }}
          />
        </div>
        {showFull && (
          <div className="brand-text">
            <strong>MundoTrabajos</strong>
            <small>Administración</small>
          </div>
        )}
        <button className="sidebar-toggle-btn" onClick={onToggle} aria-label="Contraer menú">
          {isCollapsed ? <FaAngleRight /> : <FaAngleLeft />}
        </button>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            title={isCollapsed && !isMobile ? item.label : ''}
            onClick={closeMobile}
          >
            <span className="nav-icon">{item.icon}</span>
            {showFull && <span className="nav-label">{item.label}</span>}
          </Link>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="staff-info">
          <div className="staff-avatar">{staff?.name?.[0]?.toUpperCase()}</div>
          {showFull && (
            <div className="staff-details">
              <strong>{staff?.name}</strong>
              <small>Administradora</small>
            </div>
          )}
        </div>
        <button onClick={handleLogout} className="btn-logout" title={isCollapsed && !isMobile ? 'Cerrar sesión' : ''}>
          <span className="logout-icon"><FaSignOutAlt /></span>
          {showFull && <span className="logout-text">Cerrar sesión</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
